import * as React from 'react';
import NumberCard from '../../components/Charts/NumberCard';
import Statistics from '../../components/Query/Statistics';
import CacheCrawler from '../../components/CacheCrawler';

import { Row, Col, Card, DatePicker } from 'antd';
import { Title } from '../../components/Layout/components';
const { RangePicker } = DatePicker;
interface DashboardProps {}
interface DashboardState {
    range?: any;
}

export default class Dashboard extends React.Component<DashboardProps, DashboardState> {
    state = {
        range: []
    };

    render() {
        return (
            <div>
                <Title>Welcome!</Title>
                {/* <Statistics range={this.state.range}>
                    {({ tracksTotals, inqueriesTotals }: any) => (
                        <Card
                            loading={tracksTotals.loading}
                            bordered={false}
                            title={<h2>Statistics</h2>}
                            extra={<RangePicker onChange={range => this.setState({ range })} />}
                        >
                            {!tracksTotals.loading && (
                                <div>
                                    <Row gutter={24}>
                                        <Col xl={6} lg={8} md={12} sm={24} style={{ marginBottom: 16 }}>
                                            <NumberCard
                                                icon="sound"
                                                color="#40AE49"
                                                title="Statistics item"
                                                value={tracksTotals.tracksTotals && tracksTotals.tracksTotals.total}
                                            />
                                        </Col>
                                        <Col xl={6} lg={8} md={12} sm={24} style={{ marginBottom: 16 }}>
                                            <NumberCard
                                                icon="credit-card"
                                                color="#40ae49"
                                                title="Statistics item"
                                                value={tracksTotals.tracksTotals && tracksTotals.tracksTotals.sold}
                                            />
                                        </Col>
                                        <Col xl={6} lg={8} md={12} sm={24} style={{ marginBottom: 16 }}>
                                            <NumberCard
                                                icon="play-circle-o"
                                                color="#40ae49"
                                                title="Statistics item"
                                                value={tracksTotals.tracksTotals && tracksTotals.tracksTotals.plays}
                                            />
                                        </Col>
                                        <Col xl={6} lg={8} md={12} sm={24} style={{ marginBottom: 16 }}>
                                            <NumberCard
                                                icon="book"
                                                color="#40AE49"
                                                title="Statistics item"
                                                value={
                                                    inqueriesTotals.inqueriesTotals &&
                                                    inqueriesTotals.inqueriesTotals.exclusivelicence
                                                }
                                            />
                                        </Col>
                                        <Col xl={6} lg={8} md={12} sm={24} style={{ marginBottom: 16 }}>
                                            <NumberCard
                                                icon="check"
                                                color="#40AE49"
                                                title="Statistics item"
                                                value={tracksTotals.tracksTotals && tracksTotals.tracksTotals.approved}
                                            />
                                        </Col>
                                        <Col xl={6} lg={8} md={12} sm={24} style={{ marginBottom: 16 }}>
                                            <NumberCard
                                                icon="clock-circle-o"
                                                color="#FFDA84"
                                                title="Statistics item"
                                                value={tracksTotals.tracksTotals && tracksTotals.tracksTotals.pending}
                                            />
                                        </Col>
                                        <Col xl={6} lg={8} md={12} sm={24} style={{ marginBottom: 16 }}>
                                            <NumberCard
                                                icon="close"
                                                color="#FF3E67"
                                                title="Statistics item"
                                                value={tracksTotals.tracksTotals && tracksTotals.tracksTotals.rejected}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Card>
                    )}
                </Statistics> */}
                <CacheCrawler />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/index.tsx